import * as Sentry from '@sentry/react';

const SENTRY_PUBLIC_DSN =
  'https://a4682bfb49584b358c967bf029a03db7@sentry.io/218617';
export const localEnv = () =>
  process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';

export const initializeSentry = (release: string, environment: string) => {
  if (!localEnv() || process.env.ENABLE_LOCAL_SENTRY_JS) {
    Sentry.init({
      dsn: SENTRY_PUBLIC_DSN,
      environment,
      release,
      debug: !!process.env.SENTRY_JS_DEBUG,
    });
  }
};
